<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-25">
      <div @click="gotoRoute('messages')">
        <stats-card header-color="primary">
          <template slot="header">
            <div class="card-icon">
              <i class="fa fa-envelope" />
            </div>
            <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
            <h3 class="title" style="color: #1565c0;" v-if="showScreeningsNumber">
              <animated-number :value="nMessages" />
            </h3>
            <h3 class="title" style="color: #1565c0;" v-if="!showScreeningsNumber">
              <md-progress-spinner :md-diameter="25" :md-stroke="3"  md-mode="indeterminate" />
            </h3>
          </template>

          <template slot="footer">
            <div class="stats" style="font-weight:400; font-size:.9rem;">
              <!--<md-icon>update</md-icon>-->
              Messages
            </div>
          </template>
        </stats-card>
      </div>
    </div>

    <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-25">
      <div @click="gotoRoute('screenings')">
        <stats-card header-color="primary">
          <template slot="header">
            <div class="card-icon">
              <!--<md-icon>equalizer</md-icon>-->
              <i class="fa fa-eye" />
            </div>
            <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
            <h3 class="title" style="color: #1565c0;" v-if="showScreeningsNumber">
              <animated-number :value="nAvailable" />
            </h3>
            <h3 class="title" style="color: #1565c0;" v-if="!showScreeningsNumber">
              <md-progress-spinner :md-diameter="25" :md-stroke="3"  md-mode="indeterminate" />
            </h3>
          </template>

          <template slot="footer">
            <div class="stats" style="font-weight:400; font-size:.9rem;">
              <!-- <md-icon>local_offer</md-icon>-->
              Screenings
            </div>
          </template>
        </stats-card>
      </div>
    </div>

    <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-25">
      <div @click="gotoRoute('onhold')">
        <stats-card header-color="primary">
          <template slot="header">
            <div class="card-icon">
              <!--<md-icon>store</md-icon>-->
              <i class="fas fa-user-md" />
            </div>
            <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
            <h3 class="title" style="color: #1565c0;" v-if="showScreeningsNumber">
              <animated-number :value="nOnHold" />
            </h3>
            <h3 class="title" style="color: #1565c0;" v-if="!showScreeningsNumber">
              <md-progress-spinner :md-diameter="25" :md-stroke="3"  md-mode="indeterminate" />
            </h3>
          </template>

          <template slot="footer">
            <div class="stats" style="font-weight:400; font-size:.9rem;">
              <!--<md-icon>date_range</md-icon>
              <animated-number :value="24"></animated-number>-->
              On-Hold
            </div>
          </template>
        </stats-card>
      </div>
    </div>

    <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-25">
      <div @click="gotoRoute('reports')">
        <stats-card header-color="primary">
          <template slot="header">
            <div class="card-icon">
              <md-icon>assignment</md-icon>
              <!--<i class="fas fa-notes-medical"></i>-->
              <!--<span class="fa fa-notes-medical fa-4x"></span>-->
            </div>
            <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
            <h3 class="title" style="color: #1565c0;" v-if="showScreeningsNumber">
              <animated-number :value="nReports" />
            </h3>
            <h3 class="title" style="color: #1565c0;" v-if="!showScreeningsNumber">
              <md-progress-spinner :md-diameter="25" :md-stroke="3"  md-mode="indeterminate" />
            </h3>
          </template>

          <template slot="footer">
            <div class="stats" style="font-weight:400; font-size:.9rem;">
              Reports
            </div>
          </template>
        </stats-card>
      </div>
    </div>

    <div class="md-layout-item md-size-100">
      <globe-activity-slim-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>language</md-icon>
          </div>
          <h4 class="title">Globe Activity</h4>
        </template>

        <template slot="content">
          <div class="md-layout">
            <div class="md-layout-item" align="Left">
              <globe-activity-slim-table />
            </div>
          </div>
        </template>
      </globe-activity-slim-card>
    </div>
  </div>
</template>

<script>
import { StatsCard, AnimatedNumber } from "@/components"
import GlobeActivitySlimCard from "@/components/GlobeChek/Cards/GlobeActivitySlimCard.vue"
import GlobeActivitySlimTable from "@/components/GlobeChek/Tables/GlobeActivitySlimTable.vue"

export default {
  components: {
    StatsCard,
    AnimatedNumber,
    GlobeActivitySlimCard,
    GlobeActivitySlimTable
  },
  data() {
    return {
      nMessages: 0,
      nAvailable: 0,
      nOnHold: 0,
      nReports: 0,
      showScreeningsNumber: false,
    }
  },
  computed: {
    numMessages() {
      return sessionStorage.getItem("adminMessages")
    },
    numAvailable() {
      return sessionStorage.getItem("adminAvailable")
    },
    numHold() {
      return sessionStorage.getItem("adminHold")
    },
    numReports() {
      return sessionStorage.getItem("adminReports")
    }
  },
  created: function () {
    this.initDash()
  },
  methods: {
    gotoRoute(r) {
      this.$router.push("/portal/admin/" + r)
    },

    initDash() {
      this.getDashboardInfo()
    },

    async getDashboardInfo() {
      const username = sessionStorage.getItem("username");
      const config = { headers: { "Content-Type": "application/json" } };
      const data = null;
      this.showScreeningsNumber = false;

      const url = `${process.env.VUE_APP_URL}/admin-dash/${username}`;
      const response = await window.axios.get(url, data, config).then(r => r.data);

      const [messages, screenings, onHold, reports] = response.split(',').map(Number);

      this.nMessages = messages;
      this.nAvailable = screenings;
      this.nOnHold = onHold;
      this.nReports = reports;
      this.showScreeningsNumber = true;

      sessionStorage.setItem("adminMessages", messages);
      sessionStorage.setItem("adminAvailable", screenings);
      sessionStorage.setItem("adminHold", onHold);
      sessionStorage.setItem("adminReports", reports);
    }

  }
}
</script>
<style lang="scss" scoped>
.md-table {
  height: 85vh;
  overflow: auto;
}
</style>
